import { watch } from 'vue'

export const waitForTruthy = async (source) => {
  if (source()) return true

  return new Promise((resolve) => {
    let stop = null

    stop = watch(source, (value) => {
      if (!value) return
      stop?.()
      resolve(true)
    })
  })
}

export const awaitScopedContextReady = async (authStore, orgStore) => {
  if (!authStore?.isAuthenticated) return false

  await waitForTruthy(() => authStore.rbacReady)

  if (!orgStore?.activeOrgId) return false

  if (!orgStore.contextReady) {
    const result = await orgStore.fetchSubOrgs()
    if (!result?.success) {
      return false
    }
  }

  await waitForTruthy(() => authStore.contextReady)
  return true
}

